import React from 'react';

import Mission from './mission';

export default function Profile(props) {
  return <Mission {...props} />;
}
